import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { activeContextReducer } from '@shared/api/reduxToolkit';
import { ACTIVE_CONTEXT_KEY } from '@shared/constants';

const activeContextPersistConfig = {
	key: ACTIVE_CONTEXT_KEY,
	version: 1,
	storage,
	whitelist: ['selectedCompanyId'],
};

export const persistedActiveContextReducer = persistReducer(
	activeContextPersistConfig,
	activeContextReducer,
);
